angular.module('bizmetryApp').controller('TreeTemplateViewController', function (
  $scope, $mdDialog, $timeout, templateInstance, TemplateInstanceService, ApiCollectionViewer
) {

  // =========================================================================
  //  BUILD treeData FROM templateInstance
  // =========================================================================

  function buildTreeData(instance) {

    console.log('EN BUILDTREEDATA. INSTANCE=', instance);

    var resourceOwners = instance.resource_owners || [];
    var resources = instance.resource_types || [];
    var attributes = instance.attribute_types || [];

    return resourceOwners.map(function (owner) {
      var resourcesForOwner = resources
        .filter(function (r) {
          return r.resource_owner && r.resource_owner.id === owner.id;
        })
        .map(function (resource) {
          var attributesForResource = attributes.filter(function (a) {
            return a.resource_id === resource.id;
          });
          return Object.assign({}, resource, { attributes: attributesForResource });
        });

      return Object.assign({}, owner, { resources: resourcesForOwner });
    });
  }

  console.log('templateINSTANCE dentro del TreeView =', templateInstance);
  var treeData = buildTreeData(templateInstance.templateConfig || templateInstance.template);

  // ─── Template metadata for toolbar ───────────────────────────────────────
  $scope.templateName = templateInstance.templateName || '-';
  $scope.templateVersion = templateInstance.templateVersion || '-';
  // =========================================================================
  //  TREE NODE BUILDER
  // =========================================================================

  function lex(a, b) {
    return (a.title || '').toLowerCase().localeCompare((b.title || '').toLowerCase());
  }

  function toTreeNodes(data) {
    return (data || []).map(function (owner, oi) {
      var ownerResources = owner.resources || [];

      var ownerNode = {
        title: owner.name,
        subtitle: owner.description,
        type: 'owner',
        collapsed: true,
        enabled: owner.enabled,
        nodeId: 'o_' + oi,
        nodes: ownerResources.map(function (res, ri) {
          return {
            title: res.name,
            subtitle: res.description,
            type: 'resource',
            created_from: res.is_resource_imported,
            collapsed: true,
            enabled: res.enabled,
            nodeId: 'r_' + oi + '_' + ri,
            nodes: (res.attributes || []).map(function (att, ai) {
              return {
                title: att.name,
                subtitle: att.description,
                collapsed: false,
                type: 'attribute',
                enabled: att.enabled,
                nodeId: 'a_' + oi + '_' + ri + '_' + ai,

                scalar_attribute_type: att.scalar_attribute_type,
                lower_bound: att.lower_bound,
                upper_bound: att.upper_bound,
                enum_values: att.enum_values,
                object_ref_type: att.resourceType && att.resourceType.name,
                regex: att.regex,
                max_length: att.max_length,

                column_metadata_name: att.column_metadata_name,
                parent_is_imported: res.is_resource_imported,

                isPrimaryKey: att.isPrimaryKey,
                isResourceNameField: att.isResourceNameField,
                isResourceDescriptionField: att.isResourceDescriptionField,
                isSensitive: att.isSensitive,

                resourceNameJsonPath: att.resourceNameJsonPath,
                resourceDescriptionJsonPath: att.resourceDescriptionJsonPath,

                nodes: []
              };
            }).sort(lex)   // attributes A→Z
          };
        }).sort(lex)       // ASBOs A→Z
      };

      ownerNode.totalAttributeCount = ownerNode.nodes.reduce(function (sum, res) {
        return sum + (res.nodes ? res.nodes.length : 0);
      }, 0);

      return ownerNode;
    }).sort(lex);          // Domains A→Z
  }

  // =========================================================================
  //  INIT TREE
  // =========================================================================

  $scope.tree = {
    nodes: toTreeNodes(treeData),
    dragEnabled: false
  };

  function initializeCollapsed(nodes) {
    angular.forEach(nodes, function (node) {
      if (node.nodes && node.nodes.length > 0) {
        node.collapsed = true;
        initializeCollapsed(node.nodes);
      }
    });
  }

  initializeCollapsed($scope.tree.nodes);

  // =========================================================================
  //  DIALOG
  // =========================================================================

  $scope.closeDialog = function () { $mdDialog.hide(); };

  // =========================================================================
  //  EXPAND / COLLAPSE ALL
  // =========================================================================

  $scope.expandAll = function () {
    (function expand(nodes) {
      angular.forEach(nodes, function (node) {
        node.collapsed = false;
        if (node.nodes && node.nodes.length) expand(node.nodes);
      });
    })($scope.tree.nodes);
  };

  $scope.collapseAll = function () {
    (function collapse(nodes) {
      angular.forEach(nodes, function (node) {
        node.collapsed = true;
        if (node.nodes && node.nodes.length) collapse(node.nodes);
      });
    })($scope.tree.nodes);
  };

  $scope.toggleCollapsed = function (node) {
    node.collapsed = !node.collapsed;
  };

  // =========================================================================
  //  CLIENT TYPES
  // =========================================================================
  var config = (templateInstance.templateConfig || templateInstance.template) || {};

  $scope.clientTypes = config.client_types || [];
  $scope.frameTypes = config.frame_types || [];

  $scope.selectedTabIndex = 0;

  $scope.isCtEnabled = function (ct) {
    var v = ct.enabled;
    return v === true || v === 'true' || v === 1 || v === '1';
  };

  $scope.ctEnabledCount = function () {
    return ($scope.clientTypes || []).filter($scope.isCtEnabled).length;
  };

  $scope.getClientTypeColor = function (clientTypeId) {
    var hash = 0;
    for (var i = 0; i < clientTypeId.length; i++) {
      hash = clientTypeId.charCodeAt(i) + ((hash << 5) - hash);
    }
    var hue = Math.abs(hash) % 360;
    if (hue > 55 && hue < 80) hue = (hue + 40) % 360;
    return 'hsl(' + hue + ', 65%, 48%)';
  };

  $scope.getClientTypeBg = function (clientTypeId) {
    var hash = 0;
    for (var i = 0; i < clientTypeId.length; i++) {
      hash = clientTypeId.charCodeAt(i) + ((hash << 5) - hash);
    }
    var hue = Math.abs(hash) % 360;
    if (hue > 55 && hue < 80) hue = (hue + 40) % 360;
    return 'hsl(' + hue + ', 65%, 97%)';
  };

  // =========================================================================
  //  SEARCH
  // =========================================================================

  $scope.searchQuery = '';
  $scope.searchResults = null;   // null = not searched; [] = no matches
  $scope.activeResult = null;
  $scope.searchFocused = false;
  $scope.searchResultsCollapsed = false;

  function matchesQuery(node, q) {
    var t = (node.title || '').toLowerCase();
    var s = (node.subtitle || '').toLowerCase();
    return t.indexOf(q) !== -1 || s.indexOf(q) !== -1;
  }

  function clearAllHighlights(nodes) {
    angular.forEach(nodes, function (node) {
      node.highlighted = false;
      if (node.nodes) clearAllHighlights(node.nodes);
    });
  }

  $scope.performSearch = function () {
    clearAllHighlights($scope.tree.nodes);
    $scope.activeResult = null;
    $scope.searchResultsCollapsed = false;

    var q = ($scope.searchQuery || '').toLowerCase().trim();
    if (q.length < 2) {
      $scope.searchResults = null;
      return;
    }

    var results = [];

    angular.forEach($scope.tree.nodes, function (owner) {
      if (matchesQuery(owner, q)) {
        results.push({
          type: 'owner',
          typeLabel: 'Domain',
          title: owner.title,
          subtitle: owner.subtitle,
          breadcrumb: owner.title,
          ownerNode: owner,
          nodeId: owner.nodeId
        });
      }

      angular.forEach(owner.nodes, function (resource) {
        if (matchesQuery(resource, q)) {
          results.push({
            type: 'resource',
            typeLabel: 'ASBO',
            title: resource.title,
            subtitle: resource.subtitle,
            breadcrumb: owner.title,
            ownerNode: owner,
            resourceNode: resource,
            nodeId: resource.nodeId
          });
        }

        angular.forEach(resource.nodes, function (attr) {
          if (matchesQuery(attr, q)) {
            results.push({
              type: 'attribute',
              typeLabel: 'Attribute',
              title: attr.title,
              subtitle: attr.subtitle,
              breadcrumb: owner.title + ' › ' + resource.title,
              ownerNode: owner,
              resourceNode: resource,
              attributeNode: attr,
              nodeId: attr.nodeId
            });
          }
        });
      });
    });

    var typeOrder = { owner: 0, resource: 1, attribute: 2 };
    results.sort(function (a, b) {
      var groupDiff = typeOrder[a.type] - typeOrder[b.type];
      if (groupDiff !== 0) return groupDiff;
      return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
    });

    var lastType = null;
    results.forEach(function (r) {
      r.isGroupStart = (r.type !== lastType);
      lastType = r.type;
    });

    $scope.searchResults = results;
  };

  // Center a search result below its ancestor headers, including wrapped titles.
  function scrollBelowAncestors(el, container) {
    var headerHeight = 0;
    for (var ancestor = el.parentElement; ancestor && ancestor !== container; ancestor = ancestor.parentElement) {
      var header = null;
      if (ancestor.classList.contains('bm-tree-node')) header = ancestor.querySelector(':scope > .bm-tree-row');
      else if (ancestor.classList.contains('ft-card')) header = ancestor.querySelector(':scope > .ft-card-header');
      if (header && header !== el && !header.contains(el)) headerHeight += header.getBoundingClientRect().height;
    }
    // A header result can already be sticky; measure its original flow position.
    var position = el.style.position;
    el.style.position = 'relative';
    var rect = el.getBoundingClientRect();
    var top = rect.top - container.getBoundingClientRect().top + container.scrollTop;
    el.style.position = position;
    var available = container.clientHeight - headerHeight;
    var inset = headerHeight + Math.max(12, (available - rect.height) / 2);
    container.scrollTo({ top: Math.max(0, top - inset), behavior: 'smooth' });
  }

  $scope.navigateToResult = function (result) {
    clearAllHighlights($scope.tree.nodes);

    result.ownerNode.collapsed = false;
    if (result.resourceNode) result.resourceNode.collapsed = false;

    var target = result.attributeNode || result.resourceNode || result.ownerNode;
    target.highlighted = true;
    $scope.activeResult = result;
    $scope.searchResultsCollapsed = true;

    var elId = 'bm-node-' + result.nodeId;

    function scrollToEl() {
      var el = document.getElementById(elId);
      if (!el) return false;

      var container = el.closest('.bm-tree-container');
      if (!container) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }

      scrollBelowAncestors(el, container);
      return true;
    }

    $timeout(function () {
      if (!scrollToEl()) {
        $timeout(scrollToEl, 300);
      }
    }, 80);
  };

  $scope.toggleSearchResults = function () {
    $scope.searchResultsCollapsed = !$scope.searchResultsCollapsed;
  };

  $scope.clearSearch = function () {
    $scope.searchQuery = '';
    $scope.searchResults = null;
    $scope.activeResult = null;
    $scope.searchResultsCollapsed = false;
    clearAllHighlights($scope.tree.nodes);
  };

  // =========================================================================
  //  DEBUG
  // =========================================================================

  console.log('[TreeTemplateViewController] templateInstance =>', templateInstance);
  console.log('[TreeTemplateViewController] treeData built   =>', treeData);
  console.log('[TreeTemplateViewController] clientTypes      =>', $scope.clientTypes);

  // =========================================================================
  //  FRAME TYPES
  // =========================================================================

  // =========================================================================
  //  API COLLECTIONS — the collection versions associated with this template version
  //  (one version per collection), with the biz events of the template that use them.
  //  Only template instances have them: a master template (profile wizard) doesn't.
  // =========================================================================

  $scope.apiCollections = [];
  $scope.apiCollectionsState = 'loading';   // loading | ready | error | unsupported
  $scope.apiCollectionsError = null;

  var isTemplateInstance = !!(templateInstance && templateInstance.id && templateInstance.templateConfig);

  function loadApiCollections() {
    $scope.apiCollectionsState = 'loading';
    TemplateInstanceService.getApiCollections(templateInstance.id, { skipLoader: true })
      .then(function (response) {
        var items = (response && response.data && response.data.api_collections) || [];
        $scope.apiCollections = items.slice().sort(function (a, b) {
          return (a.collection_name || '').toLowerCase().localeCompare((b.collection_name || '').toLowerCase());
        });
        $scope.apiCollectionsState = 'ready';
      })
      .catch(function (err) {
        $scope.apiCollectionsError = (err && err.data && err.data.message) || 'Could not load the API collections.';
        $scope.apiCollectionsState = 'error';
      });
  }

  if (!isTemplateInstance) {
    $scope.apiCollectionsState = 'unsupported';
  } else {
    loadApiCollections();
  }

  // Details of the associated version; it can be edited from there. An edit of a
  // PUBLISHED version forks a new DRAFT, the association itself doesn't change.
  $scope.viewApiCollection = function (ac) {
    ApiCollectionViewer.openDetails(ac.collection_id, { allowEdit: true }).then(function (result) {
      if (result) { loadApiCollections(); }
    });
  };

  $scope.acPublishedCount = function () {
    return $scope.apiCollections.filter(function (c) { return c.status === 'PUBLISHED'; }).length;
  };

  // DRAFT, PENDING_REVIEW, APPROVED, PUBLISHED, REJECTED, RETIRED → CSS modifier and label
  $scope.acStatusClass = function (status) {
    return 'ac-status-' + String(status || 'unknown').toLowerCase().replace(/_/g, '-');
  };
  $scope.acStatusLabel = function (status) {
    return String(status || 'Unknown').replace(/_/g, ' ');
  };

  // =========================================================================
  //  FRAME TYPES SEARCH
  // =========================================================================

  $scope.ftSearchQuery = '';
  $scope.ftSearchResults = null;
  $scope.ftActiveResult = null;
  $scope.ftSearchFocused = false;
  $scope.ftSearchResultsCollapsed = false;

  function clearFtHighlights() {
    angular.forEach($scope.frameTypes, function (ft) {
      ft.highlighted = false;
      angular.forEach(ft.frame_fields || [], function (f) {
        f.highlighted = false;
        angular.forEach(f.nested_table_columns || [], function (c) { c.highlighted = false; });
      });
    });
  }

 // Justo debajo de $scope.ftSearchResultsCollapsed = false;
  $scope.ftSearchMode = 'both'; // 'name' | 'desc' | 'both'

  // Reemplaza performFtSearch completo:
  $scope.performFtSearch = function () {
    clearFtHighlights();
    $scope.ftActiveResult = null;
    $scope.ftSearchResultsCollapsed = false;

    var q = ($scope.ftSearchQuery || '').toLowerCase().trim();
    if (q.length < 2) { $scope.ftSearchResults = null; return; }

    var mode = $scope.ftSearchMode;

    function matches(name, desc) {
      var inName = (name || '').toLowerCase().indexOf(q) !== -1;
      var inDesc = (desc || '').toLowerCase().indexOf(q) !== -1;
      if (mode === 'name') return inName;
      if (mode === 'desc') return inDesc;
      return inName || inDesc;
    }

    var results = [];

    angular.forEach($scope.frameTypes, function (ft) {
      if (matches(ft.frame_name, ft.frame_description)) {
        results.push({
          type: 'frametype', typeLabel: 'Frame Type',
          title: ft.frame_name, subtitle: ft.frame_description,
          breadcrumb: ft.frame_name,
          ftNode: ft, nodeId: ft.frame_type_id
        });
      }
      angular.forEach(ft.frame_fields || [], function (field) {
        if (matches(field.frame_field_name, field.frame_field_desc)) {
          results.push({
            type: 'field', typeLabel: 'Field',
            title: field.frame_field_name, subtitle: field.frame_field_desc,
            breadcrumb: ft.frame_name,
            ftNode: ft, fieldNode: field, nodeId: field.frame_component_id
          });
        }
        // NESTED_TABLE columns: a match lands on the column's row inside its table
        angular.forEach(field.nested_table_columns || [], function (col, idx) {
          if (matches(col.column_name, col.column_description)) {
            results.push({
              type: 'column', typeLabel: 'Column',
              title: col.column_name, subtitle: col.column_description,
              breadcrumb: ft.frame_name + ' › ' + field.frame_field_name + ' › #' + (idx + 1),
              ftNode: ft, colNode: col, nodeId: field.frame_component_id + '-' + idx
            });
          }
        });
      });
    });

    var typeOrder = { frametype: 0, field: 1, column: 2 };
    results.sort(function (a, b) {
      var g = typeOrder[a.type] - typeOrder[b.type];
      return g !== 0 ? g : a.title.toLowerCase().localeCompare(b.title.toLowerCase());
    });

    var lastType = null;
    results.forEach(function (r) { r.isGroupStart = (r.type !== lastType); lastType = r.type; });

    $scope.ftSearchResults = results;
  };

  // Agrega también este helper para que el modo se pueda cambiar re-ejecutando la búsqueda:
  $scope.setFtSearchMode = function (mode) {
    $scope.ftSearchMode = mode;
    if ($scope.ftSearchQuery && $scope.ftSearchQuery.length >= 2) {
      $scope.performFtSearch();
    }
  };

  $scope.navigateToFtResult = function (result) {
    clearFtHighlights();
    result.ftNode.collapsed = false;
    result.ftNode.highlighted = (result.type === 'frametype');
    if (result.fieldNode) result.fieldNode.highlighted = true;
    if (result.colNode) result.colNode.highlighted = true;
    $scope.ftActiveResult = result;
    $scope.ftSearchResultsCollapsed = true;

    var targetId = result.colNode ? 'ft-col-' + result.nodeId
      : result.fieldNode ? 'ft-field-' + result.nodeId
      : 'ft-card-' + result.nodeId;

    $timeout(function () {
      var el = document.getElementById(targetId);
      if (!el) return;
      var container = el.closest('.ft-scroll-area');
      if (!container) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      scrollBelowAncestors(el, container);
    }, 80);
  };

  $scope.toggleFtSearchResults = function () {
    $scope.ftSearchResultsCollapsed = !$scope.ftSearchResultsCollapsed;
  };

  $scope.clearFtSearch = function () {
    $scope.ftSearchQuery = '';
    $scope.ftSearchResults = null;
    $scope.ftActiveResult = null;
    $scope.ftSearchResultsCollapsed = false;
    clearFtHighlights();
  };

  // Inicializar collapsed en cada frame type
  angular.forEach($scope.frameTypes, function (ft) {
    ft.collapsed = true;
  });



  $scope.ftEnabledCount = function () {
    return ($scope.frameTypes || []).filter(function (ft) {
      var v = ft.enabled;
      return v === true || v === 'true' || v === 1 || v === '1';
    }).length;
  };

  $scope.getFieldCountByType = function (ft, type) {
    return (ft.frame_fields || []).filter(function (f) {
      return f.frame_component_type === type;
    }).length;
  };

  $scope.getComponentLabel = function (type) {
    var labels = {
      'CUSTOM': 'Custom',
      'FIELD_REFERENCE': 'Field Ref',
      'OBJECT_REFERENCE': 'Object Ref',
      'OBJECT_FIELD_REF': 'Object Field Ref',
      'NESTED_TABLE': 'Nested'
    };
    return labels[type] || type;
  };

  // ── Nested-table columns ── (a missing column_type is a SCALAR REF column)
  var NESTED_COLUMN_LABELS = {
    'SCALAR': 'SCALAR REF', 'OBJECT_REF': 'OBJECT REF',
    'OBJECT_FIELD_REF': 'OBJECT FIELD REF', 'SCALAR_INLINE': 'SCALAR INLINE'
  };
  $scope.nestedColLabel = function (col) {
    return NESTED_COLUMN_LABELS[col.column_type || 'SCALAR'] || col.column_type;
  };
  $scope.nestedColPillClass = function (col) {
    switch (col.column_type) {
      case 'OBJECT_REF': case 'OBJECT_FIELD_REF': return 'ft-pill-object-ref';
      case 'SCALAR_INLINE': return 'ft-pill-custom';
      default: return 'ft-pill-field-ref';
    }
  };
  // OBJECT REF / OBJECT FIELD REF columns point at an object (found by its id)
  $scope.nestedColIsObject = function (col) {
    return col.column_type === 'OBJECT_REF' || col.column_type === 'OBJECT_FIELD_REF';
  };
  // SCALAR REF / OBJECT FIELD REF columns also name one attribute of that resource type
  $scope.nestedColHasAttribute = function (col) {
    return !col.column_type || col.column_type === 'SCALAR' || col.column_type === 'OBJECT_FIELD_REF';
  };

});
// Keep the actual ancestor rows interactive while their descendants scroll.
angular.module('bizmetryApp').directive('bmStickyAncestors', function () {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var container = element[0];
      var frame = null;
      var disposed = false;
      var observed = new Set();
      var selector = '.bm-tree-node > .bm-tree-row, .ft-card-header';
      var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

      function schedule() {
        if (!disposed && frame === null) frame = window.requestAnimationFrame(update);
      }

      function update() {
        frame = null;
        var rows = Array.prototype.slice.call(container.querySelectorAll(selector));
        observed.forEach(function (row) {
          if (!container.contains(row)) {
            if (resizeObserver) resizeObserver.unobserve(row);
            observed.delete(row);
          }
        });
        rows.forEach(function (row) {
          if (!observed.has(row)) {
            observed.add(row);
            if (resizeObserver) resizeObserver.observe(row);
          }
          var branch = row.parentElement;
          var children = branch.querySelector(':scope > .tree-children');
          var sticky = row.classList.contains('ft-card-header') ||
            !!(children && children.children.length && !children.classList.contains('hidden'));
          row.classList.toggle('bm-sticky-ancestor', sticky);
          if (!sticky) {
            row.style.removeProperty('--bm-sticky-top');
            row.style.removeProperty('--bm-sticky-z');
            return;
          }
          var top = 0;
          var depth = 0;
          for (var ancestor = branch.parentElement; ancestor && ancestor !== container; ancestor = ancestor.parentElement) {
            if (!ancestor.classList.contains('bm-tree-node')) continue;
            var header = ancestor.querySelector(':scope > .bm-tree-row');
            if (header && header.classList.contains('bm-sticky-ancestor')) {
              top += header.getBoundingClientRect().height;
              depth++;
            }
          }
          row.style.setProperty('--bm-sticky-top', top + 'px');
          row.style.setProperty('--bm-sticky-z', String(100 - depth));
        });
      }

      var mutationObserver = new MutationObserver(schedule);
      // Angular adds/removes branches and toggles classes when filtering or collapsing.
      mutationObserver.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      if (resizeObserver) resizeObserver.observe(container);
      window.addEventListener('resize', schedule);
      schedule();
      scope.$on('$destroy', function () {
        disposed = true;
        if (frame !== null) window.cancelAnimationFrame(frame);
        mutationObserver.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        window.removeEventListener('resize', schedule);
        observed.clear();
      });
    }
  };
});
